export enum RoleEnum {
    Admin = 1,
    User = 2,
    Agent = 3,
    Client = 4
}

export enum RoleStringEnum {
    Admin = "Admin",
    User = "User",
    Agent = "Agent",
    Client = "Client"
}
